{
  "hub": {
    "title": "Alle taken",
    "description": "Alle taken in deze organisatie: wie eraan werkt, hoe ze ervoor staan en wat jouw aandacht nodig heeft.",
    "new": "Nieuwe taak",
    "openBoard": "Bord",
    "search": "Taken zoeken…",
    "live": "Realtime",
    "liveHint": "Wijzigingen van agents en collega's verschijnen direct.",
    "offline": "Opnieuw verbinden",
    "offlineHint": "Live-updates zijn gepauzeerd; de lijst wordt om de paar seconden ververst.",
    "attention_one": "{{count}} taak heeft je nodig",
    "attention_other": "{{count}} taken hebben je nodig",
    "attentionWaiting_one": "{{count}} wacht op invoer",
    "attentionWaiting_other": "{{count}} wachten op invoer",
    "attentionReview_one": "{{count}} te beoordelen",
    "attentionReview_other": "{{count}} te beoordelen",
    "columns": {
      "task": "Taak",
      "status": "Taakstatus",
      "priority": "Prioriteit",
      "assignee": "Toegewezen aan",
      "progress": "Voortgang",
      "due": "Deadline",
      "updated": "Bijgewerkt"
    },
    "filters": {
      "allStatuses": "Alle statussen",
      "allProjects": "Alle projecten",
      "standalone": "Geen project",
      "allAssignees": "Iedereen",
      "allPriorities": "Elke prioriteit",
      "sort": "Sorteren",
      "sortBy": "Sortering: {{order}}",
      "clear": "Filters wissen"
    },
    "empty": {
      "title": "Nog geen taken",
      "description": "Maak een taak en geef die aan een agent, een team of de gedeelde pool."
    },
    "emptyFiltered": {
      "title": "Geen taken gevonden",
      "description": "Geen taken voldoen aan deze filters. Probeer een andere zoekopdracht of wis de filters."
    }
  },
  "board": {
    "title": "Bord",
    "description": "Sleep taken tussen kolommen om ze door de workflow te bewegen, of zet ze op volgorde van belang.",
    "openList": "Lijst",
    "laneEmpty": "Niets hier",
    "needsInput": "Invoer nodig",
    "working": "Bezig",
    "showAll_one": "Alle {{count}} tonen",
    "showAll_other": "Alle {{count}} tonen",
    "showRecent": "Alleen recente tonen",
    "notAllowed": "Een taak kan niet van {{from}} naar {{to}}.",
    "moveRejected": "De taak kon daar niet heen (controleer toewijzing, invoer en afhankelijkheden).",
    "truncated": "{{shown}} van {{total}} taken getoond — verfijn de filters voor de rest.",
    "a11y": {
      "instructions": "Druk op spatie om een taak op te pakken. Verplaats met de pijltjestoetsen, zet neer met spatie en annuleer met escape. Druk op enter om te openen.",
      "picked": "{{title}} opgepakt.",
      "over": "{{title}} staat boven {{lane}}.",
      "dropped": "{{title}} neergezet in {{lane}}.",
      "cancelled": "Verplaatsen geannuleerd."
    }
  },
  "task": {
    "detailTitle": "Taak",
    "detailDescription": "Taakdetails, gesprek en activiteit",
    "backToList": "Alle taken",
    "notFound": "Taak niet gevonden",
    "waitingOn_one": "Wacht op {{count}} taak",
    "waitingOn_other": "Wacht op {{count}} taken",
    "status": {
      "backlog": "Werkvoorraad",
      "todo": "Te doen",
      "progress": "Bezig",
      "review": "Ter beoordeling",
      "blocked": "Geblokkeerd",
      "done": "Klaar",
      "waiting": "Wacht op invoer",
      "failed": "Mislukt",
      "cancelled": "Geannuleerd"
    },
    "priority": {
      "urgent": "Dringend",
      "high": "Hoog",
      "normal": "Normaal",
      "low": "Laag"
    },
    "closure": {
      "success": "Voltooid",
      "failed": "Mislukt",
      "cancelled": "Geannuleerd"
    },
    "order": {
      "sort_order": "Handmatige volgorde",
      "updated_at": "Recent bijgewerkt",
      "created_at": "Nieuwste",
      "due_at": "Deadline",
      "priority": "Prioriteit"
    },
    "assignee": {
      "unassigned": "Niet toegewezen",
      "pool": "Gedeelde pool",
      "poolHint": "Een beschikbare agent pakt hem op",
      "agent": "AI-agent",
      "team": "Agentteam"
    },
    "fields": {
      "title": "Titel",
      "description": "Omschrijving",
      "descriptionPlaceholder": "Wat moet er gebeuren? Markdown wordt ondersteund.",
      "expectedOutput": "Verwacht resultaat",
      "expectedOutputPlaceholder": "Hoe ziet een goed resultaat eruit?",
      "project": "In project",
      "noProject": "Geen project",
      "priority": "Prioriteit",
      "assignee": "Toegewezen aan",
      "due": "Deadline",
      "status": "Taakstatus",
      "progress": "Voortgang",
      "labels": "Etiketten",
      "labelsPlaceholder": "Label toevoegen…",
      "requiredInputs": "Vereiste invoer",
      "requiredInputsHint": "De taak wacht in de backlog tot iemand deze invult.",
      "requiredInputsPlaceholder": "bijv. klant_email",
      "autoStart": "Automatisch starten",
      "autoStartHint": "Direct naar de uitvoerder sturen zodra de taak klaar is om te starten.",
      "autoStartOn": "Start zodra klaar",
      "autoStartOff": "Handmatig starten",
      "createdBy": "Gemaakt door",
      "created": "Gemaakt",
      "updated": "Bijgewerkt",
      "started": "Gestart",
      "completed": "Afgesloten"
    },
    "create": {
      "title": "Nieuwe taak",
      "description": "Beschrijf het werk en kies wie het doet. Agents beginnen zodra de taak klaar is en gestart wordt.",
      "submit": "Taak maken"
    },
    "actions": {
      "open": "Openen",
      "openPage": "Openen als pagina",
      "start": "Starten",
      "retry": "Opnieuw proberen",
      "markReady": "Klaarzetten",
      "moveTo": "Verplaatsen naar",
      "complete": "Markeren als klaar",
      "cancel": "Taak annuleren",
      "delete": "Taak verwijderen",
      "editTitle": "Titel bewerken",
      "more": "Acties voor {{title}}"
    },
    "confirm": {
      "completeTitle": "Deze taak als klaar markeren?",
      "completeDescription": "“{{title}}” wordt afgesloten als voltooid. Een agent die er nog aan werkt, wordt gestopt.",
      "blockTitle": "Deze taak blokkeren?",
      "blockDescription": "Geblokkeerde taken stoppen tot de blokkade is opgeheven. Geef aan wat in de weg zit.",
      "blockReason": "Reden (optioneel)",
      "cancelTitle": "Deze taak annuleren?",
      "cancelDescription": "“{{title}}” wordt afgesloten als geannuleerd en een lopende agent wordt gestopt.",
      "keep": "Taak behouden",
      "deleteTitle": "Deze taak verwijderen?",
      "deleteDescription": "“{{title}}” en de geschiedenis worden definitief verwijderd. Dit kan niet ongedaan worden gemaakt."
    },
    "blockers": {
      "unassigned": "Wijs de taak toe om te starten",
      "inputs": "Ontbrekende invoer: {{fields}}",
      "dependencies_one": "Wacht op {{count}} onafgeronde taak",
      "dependencies_other": "Wacht op {{count}} onafgeronde taken"
    },
    "human": {
      "approvalTitle": "Goedkeuring nodig",
      "approvalBody": "De agent wil {{tool}} uitvoeren en heeft jouw akkoord nodig.",
      "aTool": "een tool",
      "notePlaceholder": "Optionele notitie voor de agent…",
      "approve": "Goedkeuren",
      "deny": "Weigeren",
      "approved": "Goedgekeurd",
      "denied": "Geweigerd",
      "questionTitle": "De agent heeft een vraag",
      "options": "Voorgestelde antwoorden",
      "answerPlaceholder": "Jouw antwoord…",
      "answerHint": "De agent gaat verder zodra je antwoordt. Ctrl/⌘ + Enter om te versturen.",
      "sendAnswer": "Antwoord versturen"
    },
    "review": {
      "title": "Klaar voor beoordeling",
      "description": "Accepteer het resultaat om de taak af te sluiten, keur goed zodat het werk doorgaat, of vraag om aanpassingen.",
      "placeholder": "Feedback of instructies (optioneel)…",
      "accept": "Accepteren en afsluiten",
      "approveContinue": "Goedkeuren en doorgaan",
      "requestChanges": "Aanpassingen vragen"
    },
    "followUp": {
      "placeholder": "Vraag de agent om een vervolg…",
      "hint": "Heropent de taak en zet het gesprek met de agent voort.",
      "send": "Vervolg versturen"
    },
    "inputs": {
      "title": "Invoer",
      "missing": "Vul de vereiste invoer in om de taak klaar te zetten: {{fields}}",
      "save": "Invoer opslaan"
    },
    "checklist": {
      "title": "Controlelijst",
      "progress": "{{done}} van {{total}} klaar",
      "add": "Item toevoegen…",
      "remove": "“{{item}}” verwijderen"
    },
    "live": {
      "title": "Realtime",
      "connecting": "Verbinden met de agent…",
      "working": "De agent is bezig…",
      "finished": "Run afgerond",
      "reasoning": "Redenering",
      "noOutput": "Nog geen uitvoer.",
      "openRun": "Run bekijken"
    },
    "failure": {
      "title": "De laatste run is mislukt",
      "hint": "Los de oorzaak op — wijs de taak bijvoorbeeld aan iemand anders toe — en probeer het opnieuw."
    },
    "sections": {
      "result": "Resultaat",
      "dependencies": "Afhankelijk van",
      "dependents": "Blokkeert",
      "properties": "Eigenschappen"
    },
    "dependencies": {
      "add": "Taak toevoegen om op te wachten…",
      "remove": "Niet meer wachten op “{{title}}”"
    },
    "empty": {
      "description": "Omschrijving toevoegen…",
      "expectedOutput": "Beschrijf het verwachte resultaat…"
    },
    "output": {
      "title": "Projectgegevens",
      "description": "Sla een waarde op in de gedeelde gegevens van {{project}} zodat andere taken en agents die kunnen gebruiken.",
      "key": "Sleutel",
      "keyPlaceholder": "bijv. samenvatting",
      "value": "Waarde",
      "save": "Opslaan in project"
    },
    "timeline": {
      "conversation": "Gesprek",
      "activity": "Activiteit",
      "noConversation": "Nog geen berichten",
      "noConversationHint": "Opmerkingen, updates van agents en vragen verschijnen hier.",
      "noActivity": "Nog geen activiteit.",
      "requested": "vroeg",
      "answered": "antwoordde",
      "followUp": "vervolg",
      "workflowNote": "workflownotitie",
      "you": "Iemand"
    },
    "comment": {
      "placeholder": "Schrijf een opmerking…",
      "hint": "Zichtbaar voor mensen en agents bij deze taak.",
      "post": "Plaatsen"
    },
    "events": {
      "created": "Heeft de taak gemaakt",
      "assigned": "Toegewezen aan {{assignee}}",
      "statusChanged": "Verplaatst van {{from}} naar {{to}}",
      "retried": "Heeft de taak opnieuw geprobeerd",
      "reopened": "Heeft de taak heropend",
      "started": "Heeft de taak gestart",
      "approved": "Goedgekeurd",
      "inputSubmitted": "Invoer gegeven: {{keys}}",
      "blocked": "Heeft de taak geblokkeerd",
      "blockedReason": "Geblokkeerd: {{reason}}",
      "unblocked": "Heeft de blokkade opgeheven",
      "progress": "Voortgang {{percent}}%",
      "reordered": "Herschikt in {{status}}",
      "checklistChecked": "“{{item}}” afgevinkt",
      "checklistUnchecked": "“{{item}}” niet meer afgevinkt",
      "checklistUpdated": "Heeft de checklist bijgewerkt",
      "approvalRequested": "Vroeg goedkeuring voor {{tool}}"
    },
    "toast": {
      "created": "Taak “{{title}}” gemaakt",
      "deleted": "Taak “{{title}}” verwijderd",
      "inputsSaved": "Invoer opgeslagen",
      "started": "Taak gestart",
      "retried": "Taak opnieuw gestart",
      "approved": "Goedgekeurd — het werk gaat door",
      "messageSent": "Verstuurd naar de agent",
      "cancelled": "Taak geannuleerd",
      "outputSaved": "“{{key}}” opgeslagen in het project"
    }
  },
  "projects": {
    "title": "Projecten",
    "description": "Bundel taken, kennis, bestanden en regels, en laat een orchestrator het werk aansturen.",
    "detailTitle": "Projectdetails",
    "new": "Nieuw project",
    "search": "Projecten zoeken…",
    "showArchived": "Gearchiveerde tonen",
    "noDescription": "Geen omschrijving",
    "backToList": "Projecten",
    "moreActions": "Meer acties",
    "progress": "Voortgang",
    "openOfTotal": "{{open}} open van {{total}}",
    "unassigned": "Niet toegewezen",
    "on": "Aan",
    "off": "Uit",
    "archive": "Archiveren",
    "restore": "Herstellen",
    "delete": "Project verwijderen",
    "archiveTitle": "“{{name}}” archiveren?",
    "archiveDescription": "Het project verdwijnt uit de standaardlijst. Taken, kennis en data blijven bewaard en je kunt het altijd herstellen.",
    "deleteTitle": "“{{name}}” verwijderen?",
    "deleteDescription_one": "Hiermee verwijder je het project definitief, met {{count}} taak, kennis, bestanden, data en geschiedenis, en stop je alles wat nog loopt. Dit kan niet ongedaan worden gemaakt.",
    "deleteDescription_other": "Hiermee verwijder je het project definitief, met {{count}} taken, kennis, bestanden, data en geschiedenis, en stop je alles wat nog loopt. Dit kan niet ongedaan worden gemaakt.",
    "empty": {
      "title": "Nog geen projecten",
      "description": "Maak een project om samenhangende taken te groeperen en agents gedeelde kennis, bestanden en regels te geven."
    },
    "columns": {
      "project": "Projectnaam",
      "status": "Fase",
      "tasks": "Taken",
      "orchestrator": "Orchestratie",
      "updated": "Bijgewerkt"
    },
    "status": {
      "active": "Actief",
      "completed": "Afgerond",
      "archived": "Gearchiveerd"
    },
    "taskStatus": {
      "backlog": "Werkvoorraad",
      "todo": "Te doen",
      "progress": "Bezig",
      "waiting": "Wacht",
      "review": "Ter beoordeling",
      "blocked": "Geblokkeerd",
      "done": "Klaar",
      "failed": "Mislukt",
      "cancelled": "Geannuleerd"
    },
    "priority": {
      "low": "Laag",
      "normal": "Normaal",
      "high": "Hoog",
      "urgent": "Dringend"
    },
    "toast": {
      "created": "Project “{{name}}” aangemaakt",
      "saved": "Project “{{name}}” opgeslagen",
      "archived": "Project “{{name}}” gearchiveerd",
      "deleted": "Project “{{name}}” verwijderd"
    },
    "form": {
      "newTitle": "Nieuw project",
      "editTitle": "Project bewerken",
      "description": "Een project bundelt taken met de kennis, bestanden en regels die agents nodig hebben om eraan te werken.",
      "create": "Project aanmaken",
      "name": "Naam",
      "namePlaceholder": "bijv. Nieuwe website",
      "descriptionLabel": "Omschrijving",
      "descriptionPlaceholder": "Waar gaat dit project over?",
      "color": "Kleur",
      "status": "Fase",
      "statusHint": "Afgeronde projecten blijven in de lijst; gearchiveerde projecten zijn standaard verborgen.",
      "autoRun": "Vervolgtaken automatisch starten",
      "autoRunHint": "Start een vervolgtaak automatisch zodra een agent die aanmaakt. Wordt genegeerd zolang de orchestrator aan staat.",
      "maxAutoResume": "Maximaal aantal automatische starts na elkaar",
      "maxAutoResumeHint": "Hoeveel vervolgtaken automatisch mogen starten voordat een mens moet ingrijpen.",
      "maxFailures": "Mislukkingen tot escalatie",
      "maxFailuresHint": "Aantal mislukte taken op rij voordat de orchestrator een mens om hulp vraagt."
    },
    "tabs": {
      "overview": "Overzicht",
      "tasks": "Taken",
      "orchestrator": "Orchestratie",
      "knowledge": "Kennis",
      "files": "Bestanden",
      "rules": "Regels",
      "data": "Gegevens",
      "activity": "Activiteit"
    },
    "stats": {
      "tasks": "Taken",
      "open_one": "{{count}} openstaand",
      "open_other": "{{count}} openstaand",
      "completion": "Afgerond",
      "documents": "Kennisdocumenten",
      "folders_one": "{{count}} map",
      "folders_other": "{{count}} mappen",
      "files": "Bestanden"
    },
    "overview": {
      "automation": "Automatisering",
      "openOrchestrator": "Orchestrator openen",
      "orchestrator": "Orchestratie",
      "goal": "Doel",
      "noGoal": "Geen doel ingesteld",
      "lastPass": "Laatste ronde",
      "autoRun": "Vervolgtaken automatisch starten",
      "autoResumes": "Automatische starts",
      "failureStreak": "Mislukte taken op rij",
      "usedOf": "{{used}} van {{max}}",
      "created": "Aangemaakt",
      "recentActivity": "Recente activiteit",
      "viewAll": "Alles bekijken"
    },
    "export": {
      "title": "Projectlog exporteren",
      "hint": "Download het volledige auditspoor als JSON: taken met hun tijdlijn, agent-runs en toolaanroepen, orchestratorrondes, kennis, data, activiteit en benchmarks.",
      "download": "JSON-export downloaden",
      "done": "Projectexport gedownload"
    },
    "tasks": {
      "search": "Taken zoeken…",
      "openBoard": "Bord",
      "openAll": "Alle taken",
      "empty": "Nog geen taken in dit project",
      "emptyHint": "Maak er een aan met Nieuwe taak, of laat de orchestrator ze plannen.",
      "moveUp": "Omhoog",
      "moveDown": "Omlaag"
    },
    "taskColumns": {
      "title": "Taak",
      "status": "Fase",
      "priority": "Prioriteit",
      "assignee": "Toegewezen aan",
      "updated": "Bijgewerkt"
    },
    "activity": {
      "empty": "Nog geen activiteit",
      "emptyHint": "Wijzigingen door mensen, agents en de orchestrator verschijnen hier.",
      "loadOlder": "Oudere laden",
      "kinds": {
        "projectCreated": "Project aangemaakt: {{name}}",
        "projectUpdated": "Project bijgewerkt: {{fields}}",
        "projectArchived": "Project gearchiveerd",
        "taskCreated": "Taak #{{number}} aangemaakt: {{title}}",
        "taskUpdate": "Taak #{{number}}: {{text}}",
        "fileUploaded": "Bestand geüpload: {{name}}",
        "fileDeleted": "Bestand verwijderd: {{name}}",
        "docUpdated": "Kennisdocument bijgewerkt: {{location}}",
        "docDeleted": "Kennisdocument verwijderd: {{location}}",
        "folderCreated": "Kennismap aangemaakt: {{folder}}",
        "ruleAdded": "Projectregel toegevoegd: {{text}}",
        "autoResumeCap": "Limiet voor automatisch starten bereikt ({{max}}); de overige taken wachten tot iemand ze start.",
        "orchestratorReset": "Orchestrator handmatig gereset (vergrendeling opgeheven).",
        "orchestratorPass": "Orchestratorronde: {{summary}}",
        "projectDone": "De orchestrator heeft het project afgerond. {{summary}}",
        "statusSet": "De orchestrator heeft de projectstatus op {{status}} gezet.",
        "needsHuman": "De orchestrator heeft je nodig: {{message}}",
        "escalated": "Doorgezet naar een mens: {{failures}} mislukte taken op rij (limiet {{cap}}). Laatst mislukt: taak #{{number}} “{{title}}”."
      }
    },
    "rules": {
      "title": "Projectregels",
      "hint": "Korte richtlijnen die worden toegevoegd aan de instructies van elke agent die aan dit project werkt, bijv. “Schrijf alle documenten in het Nederlands”.",
      "placeholder": "Regel toevoegen…",
      "add": "Regel toevoegen",
      "added": "Regel toegevoegd",
      "deleted": "Regel verwijderd",
      "editLabel": "Tekst van de regel",
      "toggle": "Regel actief",
      "moveUp": "Omhoog",
      "moveDown": "Omlaag",
      "delete": "Regel verwijderen",
      "deleteTitle": "Deze regel verwijderen?",
      "empty": "Nog geen regels",
      "emptyHint": "Met regels werken agents consistent over alle taken in het project."
    },
    "data": {
      "hint": "Een gedeelde sleutel-waardeopslag. Agents lezen en schrijven hierin tijdens hun werk; jij kunt hem ook bewerken.",
      "search": "Data zoeken…",
      "add": "Item toevoegen",
      "newTitle": "Nieuw data-item",
      "editTitle": "“{{key}}” bewerken",
      "formDescription": "Waarden zijn platte tekst; agents slaan hier vaak JSON of Markdown op.",
      "key": "Sleutel",
      "keyPlaceholder": "bijv. doelgroep",
      "value": "Waarde",
      "valuePlaceholder": "Willekeurige tekst",
      "emptyValue": "(leeg)",
      "chars": "{{n}} tekens",
      "byRoom": "Geschreven door taakruimte #{{id}}",
      "saved": "“{{key}}” opgeslagen",
      "deleted": "“{{key}}” verwijderd",
      "delete": "Item verwijderen",
      "deleteTitle": "“{{key}}” verwijderen?",
      "deleteDescription": "Agents die deze waarde gebruiken, vinden hem dan niet meer.",
      "empty": "Nog geen gedeelde data",
      "emptyHint": "Agents schrijven hier tijdens hun werk. Je kunt ook zelf items toevoegen.",
      "noMatches": "Geen items gevonden"
    },
    "files": {
      "dropTitle": "Sleep referentiebestanden hierheen",
      "hint": "Agents kunnen deze bestanden bekijken en lezen. Documenten worden op de achtergrond naar tekst omgezet.",
      "upload": "Bestanden uploaden",
      "uploading_one": "{{count}} bestand uploaden…",
      "uploading_other": "{{count}} bestanden uploaden…",
      "uploaded": "“{{name}}” geüpload",
      "duplicate": "“{{name}}” staat al in dit project",
      "deleted": "“{{name}}” verwijderd",
      "search": "Bestanden zoeken…",
      "download": "Downloaden",
      "delete": "Bestand verwijderen",
      "deleteTitle": "“{{name}}” verwijderen?",
      "deleteDescription": "Agents kunnen dit bestand dan niet meer lezen.",
      "empty": "Nog geen bestanden geüpload.",
      "columns": {
        "name": "Bestand",
        "size": "Grootte",
        "status": "Verwerking",
        "uploaded": "Geüpload"
      },
      "status": {
        "ready": "Klaar",
        "pending": "Verwerken",
        "failed": "Mislukt"
      },
      "kind": {
        "text": "Tekst",
        "document": "Documentbestand",
        "image": "Afbeelding"
      }
    },
    "knowledge": {
      "newDoc": "Nieuw document",
      "newDocIn": "Nieuw document in {{folder}}",
      "newFolder": "Nieuwe map",
      "createFolder": "Map aanmaken",
      "folderPath": "Mappad",
      "folderPathHint": "Gebruik schuine strepen voor submappen, bijv. onderzoek/notities.",
      "downloadAll": "Alles downloaden als zip",
      "search": "Documenten zoeken…",
      "noMatches": "Geen documenten gevonden.",
      "empty": "Nog geen documenten",
      "emptyHint": "De kennisbank bevat de specificaties, het onderzoek en de besluiten van het project. Agents doorzoeken en werken hem bij tijdens hun werk.",
      "select": "Kies een document",
      "docTitle": "Titel",
      "folder": "Map",
      "folderHint": "Laat leeg voor de hoofdmap.",
      "folderPlaceholder": "bijv. specs of onderzoek/notities",
      "content": "Inhoud",
      "contentPlaceholder": "Schrijf in Markdown…",
      "renameHint": "Als je de titel of map wijzigt, wordt het document verplaatst.",
      "updated": "Bijgewerkt",
      "noContent": "Dit document is leeg.",
      "delete": "Verwijderen",
      "deleteTitle": "“{{title}}” verwijderen?",
      "deleteDescription": "Het document wordt uit de kennisbank van het project verwijderd.",
      "deleteFolder": "Map {{path}} verwijderen",
      "deleteFolderTitle": "De lege map “{{path}}” verwijderen?",
      "saved": "“{{title}}” opgeslagen",
      "deleted": "“{{title}}” verwijderd",
      "folderCreated": "Map “{{path}}” aangemaakt",
      "folderDeleted": "Map “{{path}}” verwijderd"
    },
    "orchestrator": {
      "name": "De orchestrator",
      "off": "Uit",
      "status": {
        "idle": "Inactief",
        "running": "Bezig",
        "awaiting_human": "Wacht op jou",
        "done": "Klaar"
      },
      "trigger": {
        "manual": "Handmatig",
        "chat": "Bericht",
        "task_event": "Taakupdate",
        "schedule": "Schema"
      },
      "runPass": "Ronde starten",
      "reset": "Resetten",
      "resetTitle": "Orchestrator resetten?",
      "resetDescription": "Stopt de lopende ronde en heft de vergrendeling op. Taken die al gestart zijn, lopen door.",
      "resetDone": "Orchestrator gereset",
      "settings": "Instellingen",
      "configure": "Instellen",
      "setupTitle": "Orchestrator instellen",
      "setupDescription": "Zet de orchestrator aan en kies een agent, zodat hij de taken van dit project kan plannen, aanmaken en starten.",
      "notConfigured": "Zet eerst de orchestrator aan en kies een agent.",
      "idleHint": "Inactief. Stuur een bericht of start een ronde.",
      "awaitingHint": "Wacht op jouw input. Antwoord hieronder om verder te gaan.",
      "doneHint": "Volgens de orchestrator is het doel bereikt.",
      "working": "Bezig…",
      "workingOnTasks_one": "Bezig, {{count}} taak loopt",
      "workingOnTasks_other": "Bezig, {{count}} taken lopen",
      "thinking": "Denkt na…",
      "reasoning": "Redenering",
      "noSummary": "Geen samenvatting voor deze ronde.",
      "viewRun": "Run bekijken",
      "inProgress": "Lopende taken",
      "reconnecting": "Opnieuw verbinden",
      "emptyTitle": "Nog geen gesprek",
      "emptyDescription": "Vertel de orchestrator wat je wilt bereiken, of start een ronde zodat hij vanuit het doel gaat plannen.",
      "placeholder": "Bericht aan de orchestrator…",
      "send": "Versturen",
      "queueHint": "Berichten die je tijdens een lopende ronde stuurt, worden in de volgende ronde opgepakt.",
      "coalesced": "Er loopt al een ronde; je verzoek staat klaar voor de volgende.",
      "skipped": "Er is nu niets te doen; de ronde is overgeslagen.",
      "saved": "Orchestratorinstellingen opgeslagen",
      "settingsTitle": "Orchestratorinstellingen",
      "settingsDescription": "Eén agent plant, maakt en start alle taken van dit project.",
      "enable": "Orchestrator inschakelen",
      "enableHint": "Zolang hij aan staat, start alleen de orchestrator taken; automatisch starten van vervolgtaken wordt genegeerd.",
      "agent": "Orchestrator-agent",
      "agentHint": "De instructies van de agent vormen de persona van de orchestrator.",
      "agentNone": "Geen agent",
      "agentRequired": "Kies een agent om de orchestrator in te schakelen",
      "goal": "Doel",
      "goalHint": "Het resultaat waar de orchestrator naartoe werkt.",
      "goalPlaceholder": "bijv. Plan, schrijf en review de blogpost voor de lancering",
      "budget": "Acties per ronde",
      "budgetHint": "Maximaal aantal wijzigingen dat de orchestrator in één ronde mag doen.",
      "interval": "Interval",
      "intervalHint": "Optionele periodieke ronde (5 minuten tot 7 dagen). Laat leeg om alleen bij gebeurtenissen te draaien.",
      "intervalOff": "Alleen bij gebeurtenissen",
      "minutes": "min"
    }
  }
}
